/**
 * A stable colour per robot. PURE.
 *
 * DERIVED FROM THE ID, not assigned by position in a list. A robot that moves up the
 * roster — because another went offline, or a new one appeared — must not change colour:
 * the whole point of the colour is that somebody can glance between a checkbox and a dot
 * on a map and know they are the same machine. An index-based palette breaks exactly
 * when the fleet changes, which is when people are watching.
 *
 * FNV-1a, for the same reason the cache uses it: `hash()` equivalents vary per runtime,
 * and a colour that differs between two operators' browsers makes "the blue one" a
 * sentence that cannot be said out loud.
 */

/** Hand-picked hues rather than the whole wheel. Evenly spaced hues put several robots
 *  in near-identical greens; these are chosen to stay apart, and to avoid the reds the
 *  map already uses for a robot that is off its map. */
const HUES = [205, 35, 145, 285, 15, 175, 255, 95, 320, 60];

function hash(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h;
}

/** A CSS colour for this robot, stable for the life of the id. */
export function robotColour(robotId: string): string {
  return `hsl(${HUES[hash(robotId) % HUES.length]} 70% 45%)`;
}
